window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 linkmsg.innerHTML="カラーを選択してください";
}
// PetitComサイズ画像変更
function showimg1(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/petit-kaku.gif?v=1643519716";
document.getElementById("message").innerHTML = "<p>(高さ59cm又は高さ72cm、幅55～160cmまで1cm単位でオーダー可能です。)</p>";
}
function showimg2(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/petit-jet.gif?v=1643520304";
document.getElementById("message").innerHTML = "<p>(高さ59cm又は高さ72cm、幅55～160cmまで1cm単位でオーダー可能です。)</p>";
}
function showimg3(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/petit-maru.gif?v=1643520304";
document.getElementById("message").innerHTML = "<p>(高さ59cm又は高さ72cm、幅55～160cmまで1cm単位でオーダー可能です。)</p>";
}
// PetitComサイズオーダー
function checkBtn(){
 var idCloth = document.getElementsByName( "cava_tab" ) ;
 var strCloth = "";
 var i=0;
 for ( strCloth="", i=idCloth.length; i--; ) {
  if ( idCloth[i].checked ) {
   strCloth = idCloth[i].id.slice(4);
   break ;
  }
 }
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor=""
 for (strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i].id ;
   break ;
  }
 }
 var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";
 if(strCloth.slice(0,2)!=strColor.slice(0,2)){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else if(strCloth.slice(0,2)=="mo"&&strColor.slice(0,2)=="mo"){
  if(strCloth.slice(0,3)!=strColor.slice(0,3)){
   linkmsg.style.visibility="visible";
   strErrmsg="カラーを選択してください";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =true;
     }else{
   linkmsg.style.visibility="hidden";
   linkmsg.innerHTML="";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =false;
     }
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}
function checkOption(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_depth.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
}
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,price,cloth){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.price=price;this.cloth=cloth;}
function searchURL(strHaba,strDepth,strHeight,strCloth){
var strErr;
//var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
//幅チェック
if (intHaba < 55){
 strErr="幅55cm未満";
}else if (intHaba > 160){
  strErr="幅160cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}
//幅サイズ成形
switch(strHaba.length){
 case 2:
  if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
   strHaba ="100";
  }else if(strHaba.slice(-1) !="0"){
   strHaba=parseInt(strHaba.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strHaba.slice(-1)=="0"){
   
  }else{
  strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
  }
  break;
} 
//ベース価格
var basePrice = [42000,48000,60000,65000,43000,54000,61000,80000];
var addPrice = 3000;
var addPriceMi = 4000;
var mulHaba;
var sellPrice;
var i=0
 mulHaba=(parseInt(strHaba)-60)/10;
 if(strHeight=="59" && intHaba =="55"){
  if(strCloth=="ns7" || strCloth=="sofia" || strCloth=="modern" || strCloth=="meisai"){
   sellPrice =  "39000";
  }else if(strCloth=="oct" || strCloth=="pattern" || strCloth=="resort"){
   sellPrice =  "45000";
  }else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="denim" || strCloth=="damaska" || strCloth=="damaskb" || strCloth=="holiday" || strCloth=="magic" || strCloth=="moq" || strCloth=="meta"){
   sellPrice =  "57000";
  }else if(strCloth=="michael"){
   sellPrice =  "62000";
  }else{
   alert("生地を選択してください");
   return false;
  }
 }
 else if(strHeight=="59"){
  if(strCloth=="ns7" || strCloth=="sofia" || strCloth=="modern" || strCloth=="meisai"){
   sellPrice =  parseInt(basePrice[i])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="oct" || strCloth=="pattern" || strCloth=="resort"){
   sellPrice =  parseInt(basePrice[i+1])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="denim" || strCloth=="damaska" || strCloth=="damaskb" || strCloth=="holiday" || strCloth=="magic" || strCloth=="moq" || strCloth=="meta"){
   sellPrice =  parseInt(basePrice[i+2])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="michael"){
   sellPrice =  parseInt(basePrice[i+3])+(parseInt(addPrice)*parseInt(mulHaba));
  }else{
   alert("生地を選択してください");
   return false;
  }
 }
 else if(strHeight=="72" && intHaba =="55"){
  if(strCloth=="ns7" || strCloth=="sofia" || strCloth=="modern" || strCloth=="meisai"){
   sellPrice =  "40000";
  }else if(strCloth=="oct" || strCloth=="pattern" || strCloth=="resort"){
   sellPrice =  "51000";
  }else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="denim" || strCloth=="damaska" || strCloth=="damaskb" || strCloth=="holiday" || strCloth=="magic" || strCloth=="moq" || strCloth=="meta"){
   sellPrice =  "58000";
  }else if(strCloth=="michael"){
   sellPrice =  "76000";
  }else{
   alert("生地を選択してください");
   return false;
  }
 } 
 else{
  if(strCloth=="ns7" || strCloth=="sofia" || strCloth=="modern" || strCloth=="meisai"){
   sellPrice =  parseInt(basePrice[i+4])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="oct" || strCloth=="pattern" || strCloth=="resort"){
   sellPrice =  parseInt(basePrice[i+5])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="denim" || strCloth=="damaska" || strCloth=="damaskb" || strCloth=="holiday" || strCloth=="magic" || strCloth=="moq" || strCloth=="meta"){
   sellPrice =  parseInt(basePrice[i+6])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="michael"){
   sellPrice =  parseInt(basePrice[i+7])+(parseInt(addPriceMi)*parseInt(mulHaba));
  }else{
   alert("生地を選択してください");
   return false;
  }
 }
 return sellPrice;
}
/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strCloth){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].cloth==strCloth){
return goods[i].url;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 document.getElementById("price").value =""+" 円";
 cart_price.innerHTML =""+" 円";
 cart_productform.innerHTML="";
 cart_haba.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=""
var idProductForm=document.getElementsByName( "productform" ) ;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idCloth = document.getElementsByName( "cava_tab" ) ;
var idColor = document.getElementsByName( "colortype" ) ;
var strCloth = "";
var strColor = "";
var i=0;
var a=0;
var b=0;
for ( strDepth="", b=idProductForm.length; b--; ) {
 if ( idProductForm[b].checked ) {
  strDepth = idProductForm[b].id ;
  var valueProductForm = idProductForm[b].value ;
  break ;
 }
}
for ( strCloth="", i=idCloth.length; i--; ) {
 if ( idCloth[i].checked ) {
  strCloth = idCloth[i].id.slice(4);
  var valueCloth = idCloth[i].value ;
  break ;
 }
}
for ( strColor="", a=idColor.length; a--; ) {
 if ( idColor[a].checked ) {
  strColor = idColor[a].id ;
  var valueColor = idColor[a].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strHeight+"cm"
document.getElementById("choice3").value=valueProductForm+"タイプ"
document.getElementById("choice4").value=valueCloth+"生地"
document.getElementById("choice5").value=valueColor

//商品ページの有無チェック
var valueProductForm;
if(strHeight=="72"){
var valueProductForm="Ds"+valueProductForm;}
else{}

//商品ページの有無チェック（別注色シルバーグレー追加）
var comcode=checkURL(strHaba,valueProductForm,strHeight,strCloth);
if (!comcode=="" && strColor=="moq_sgy"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="モケット生地シルバーグレーは別注色のため金額が異なります。";
}
else if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,valueProductForm,strHeight,strCloth);

if(!url){
alert("幅を入力してください");
return false;
}
if (valueProductForm=="Dskaku"){
valueProductForm="kaku";}
else if (valueProductForm=="Dsjet"){
valueProductForm="jet";}
else if(valueProductForm=="Dsmaru"){
valueProductForm="maru";}
var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_productform.innerHTML=valueProductForm;
cart_height.innerHTML=strHeight;
 cart_cloth.innerHTML=valueCloth;
 cart_color.innerHTML=valueColor;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice6").value="見積もり金額："+url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;  
 var choice3=document.frm.choice3.value;  
    var text = document.frm.inventory_id.value;
    var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }           

    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }       
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a01331","64","kaku","59","45000","sofia");
goods[1] =new setGoods("0000a01343","130","kaku","59","63000","sofia");
goods[2] =new setGoods("0000a01627","130","kaku","59","81000","moq");
goods[3] =new setGoods("0000a01638","64","kaku","59","63000","moq");
goods[4] =new setGoods("0000a01854","64","kaku","59","63000","leather");
goods[5] =new setGoods("0000a01857","130","kaku","59","81000","leather");
goods[6] =new setGoods("0000a06334","64","Dskaku","72","46000","sofia");
goods[7] =new setGoods("0000a06345","64","Dskaku","72","46000","ns7");
goods[8] =new setGoods("0000a06351","64","Dskaku","72","57000","oct");
goods[9] =new setGoods("0000a06355","64","Dskaku","72","64000","moq");
goods[10] =new setGoods("0000a06360","64","Dskaku","72","64000","leather");
goods[11] =new setGoods("0000a06364","130","Dskaku","72","64000","sofia");
goods[12] =new setGoods("0000a06375","130","Dskaku","72","64000","ns7");
goods[13] =new setGoods("0000a06381","130","Dskaku","72","75000","oct");
goods[14] =new setGoods("0000a06385","130","Dskaku","72","82000","moq");
goods[15] =new setGoods("0000a06390","130","Dskaku","72","82000","leather");
goods[16] =new setGoods("0000a06394","64","Dsmaru","72","46000","sofia");
goods[17] =new setGoods("0000a06405","64","Dsmaru","72","46000","ns7");
goods[18] =new setGoods("0000a06411","64","Dsmaru","72","57000","oct");
goods[19] =new setGoods("0000a06415","64","Dsmaru","72","64000","moq");
goods[20] =new setGoods("0000a06420","64","Dsmaru","72","64000","leather");
goods[21] =new setGoods("0000a06424","130","Dsmaru","72","64000","sofia");
goods[22] =new setGoods("0000a06435","130","Dsmaru","72","64000","ns7");
goods[23] =new setGoods("0000a06441","130","Dsmaru","72","75000","oct");
goods[24] =new setGoods("0000a06445","130","Dsmaru","72","82000","moq");
goods[25] =new setGoods("0000a06450","130","Dsmaru","72","82000","leather");
goods[26] =new setGoods("0000a10529","64","Dsjet","72","46000","sofia");
goods[27] =new setGoods("0000a10541","64","Dsjet","72","46000","ns7");
goods[28] =new setGoods("0000a10548","64","Dsjet","72","57000","oct");
goods[29] =new setGoods("0000a10552","64","Dsjet","72","64000","moq");
goods[30] =new setGoods("0000a10553","64","Dsjet","72","64000","leather");
goods[31] =new setGoods("0000a10565","130","Dsjet","72","64000","sofia");
goods[32] =new setGoods("0000a10577","130","Dsjet","72","64000","ns7");
goods[33] =new setGoods("0000a10583","130","Dsjet","72","75000","oct");
goods[34] =new setGoods("0000a10587","130","Dsjet","72","82000","moq");
goods[35] =new setGoods("0000a10588","130","Dsjet","72","82000","leather");
goods[36] =new setGoods("0000a10600","64","jet","59","45000","sofia");
goods[37] =new setGoods("0000a10612","64","jet","59","45000","ns7");
goods[38] =new setGoods("0000a10618","64","jet","59","51000","oct");
goods[39] =new setGoods("0000a10622","64","jet","59","63000","moq");
goods[40] =new setGoods("0000a10623","64","jet","59","63000","leather");
goods[41] =new setGoods("0000a10635","130","jet","59","63000","sofia");
goods[42] =new setGoods("0000a10647","130","jet","59","63000","ns7");
goods[43] =new setGoods("0000a10653","130","jet","59","69000","oct");
goods[44] =new setGoods("0000a10657","130","jet","59","81000","moq");
goods[45] =new setGoods("0000a10658","130","jet","59","81000","leather");
goods[46] =new setGoods("0000a10740","64","kaku","59","45000","ns7");
goods[47] =new setGoods("0000a10746","130","kaku","59","63000","ns7");
goods[48] =new setGoods("0000a10759","160","kaku","59","72000","sofia");
goods[49] =new setGoods("0000a10771","160","kaku","59","72000","ns7");
goods[50] =new setGoods("0000a10781","160","kaku","59","90000","moq");
goods[51] =new setGoods("0000a10782","160","kaku","59","90000","leather");
goods[52] =new setGoods("0000a10829","160","jet","59","72000","sofia");
goods[53] =new setGoods("0000a10841","160","jet","59","72000","ns7");
goods[54] =new setGoods("0000a10847","160","jet","59","78000","oct");
goods[55] =new setGoods("0000a10851","160","jet","59","90000","moq");
goods[56] =new setGoods("0000a10852","160","jet","59","90000","leather");
goods[57] =new setGoods("0000a10864","160","Dskaku","72","73000","sofia");
goods[58] =new setGoods("0000a10876","160","Dskaku","72","73000","ns7");
goods[59] =new setGoods("0000a10882","160","Dskaku","72","84000","oct");
goods[60] =new setGoods("0000a10886","160","Dskaku","72","91000","moq");
goods[61] =new setGoods("0000a10887","160","Dskaku","72","91000","leather");
goods[62] =new setGoods("0000a10899","160","Dsmaru","72","73000","sofia");
goods[63] =new setGoods("0000a10911","160","Dsmaru","72","73000","ns7");
goods[64] =new setGoods("0000a10917","160","Dsmaru","72","84000","oct");
goods[65] =new setGoods("0000a10921","160","Dsmaru","72","91000","moq");
goods[66] =new setGoods("0000a10922","160","Dsmaru","72","91000","leather");
goods[67] =new setGoods("0000a10934","160","Dsjet","72","73000","sofia");
goods[68] =new setGoods("0000a10946","160","Dsjet","72","73000","ns7");
goods[69] =new setGoods("0000a10952","160","Dsjet","72","84000","oct");
goods[70] =new setGoods("0000a10956","160","Dsjet","72","91000","moq");
goods[71] =new setGoods("0000a10957","160","Dsjet","72","91000","leather");
goods[72] =new setGoods("0000a35566","64","Dsjet","72","84000","michael");
goods[73] =new setGoods("0000a35576","130","Dsjet","72","108000","michael");
goods[74] =new setGoods("0000a35586","160","Dsjet","72","120000","michael");
goods[75] =new setGoods("0000a35596","64","Dskaku","72","84000","michael");
goods[76] =new setGoods("0000a35606","130","Dskaku","72","108000","michael");
goods[77] =new setGoods("0000a35616","160","Dskaku","72","120000","michael");
goods[78] =new setGoods("0000a35626","64","Dsmaru","72","84000","michael");
goods[79] =new setGoods("0000a35636","130","Dsmaru","72","108000","michael");
goods[80] =new setGoods("0000a35646","160","Dsmaru","72","120000","michael");
goods[81] =new setGoods("0000a35686","64","jet","59","68000","michael");
goods[82] =new setGoods("0000a35696","130","jet","59","86000","michael");
goods[83] =new setGoods("0000a35706","160","jet","59","95000","michael");
goods[84] =new setGoods("0000a41015","64","Dsjet","72","64000","denim");
goods[85] =new setGoods("0000a41020","130","Dsjet","72","82000","denim");
goods[86] =new setGoods("0000a41025","160","Dsjet","72","91000","denim");
goods[87] =new setGoods("0000a41030","64","Dskaku","72","64000","denim");
goods[88] =new setGoods("0000a41035","130","Dskaku","72","82000","denim");
goods[89] =new setGoods("0000a41040","160","Dskaku","72","91000","denim");
goods[90] =new setGoods("0000a41045","64","Dsmaru","72","64000","denim");
goods[91] =new setGoods("0000a41050","130","Dsmaru","72","82000","denim");
goods[92] =new setGoods("0000a41055","160","Dsmaru","72","91000","denim");
goods[93] =new setGoods("0000a41075","64","jet","59","63000","denim");
goods[94] =new setGoods("0000a41080","130","jet","59","81000","denim");
goods[95] =new setGoods("0000a41085","160","jet","59","90000","denim");
goods[96] =new setGoods("0000a19741","64","Dsjet","72","46000","modern");
goods[97] =new setGoods("0000a19770","64","Dsjet","72","46000","meisai");
goods[98] =new setGoods("0000a19778","64","Dsjet","72","64000","magic");
goods[99] =new setGoods("0000a19785","130","Dsjet","72","64000","modern");
goods[100] =new setGoods("0000a19814","130","Dsjet","72","64000","meisai");
goods[101] =new setGoods("0000a19822","130","Dsjet","72","82000","magic");
goods[102] =new setGoods("0000a19829","160","Dsjet","72","73000","modern");
goods[103] =new setGoods("0000a19858","160","Dsjet","72","73000","meisai");
goods[104] =new setGoods("0000a19866","160","Dsjet","72","91000","magic");
goods[105] =new setGoods("0000a19873","64","Dskaku","72","46000","modern");
goods[106] =new setGoods("0000a19902","64","Dskaku","72","46000","meisai");
goods[107] =new setGoods("0000a19910","64","Dskaku","72","64000","magic");
goods[108] =new setGoods("0000a19917","130","Dskaku","72","64000","modern");
goods[109] =new setGoods("0000a19946","130","Dskaku","72","64000","meisai");
goods[110] =new setGoods("0000a19954","130","Dskaku","72","82000","magic");
goods[111] =new setGoods("0000a19961","160","Dskaku","72","73000","modern");
goods[112] =new setGoods("0000a19990","160","Dskaku","72","73000","meisai");
goods[113] =new setGoods("0000a19998","160","Dskaku","72","91000","magic");
goods[114] =new setGoods("0000a20005","64","Dsmaru","72","46000","modern");
goods[115] =new setGoods("0000a20034","64","Dsmaru","72","46000","meisai");
goods[116] =new setGoods("0000a20042","64","Dsmaru","72","64000","magic");
goods[117] =new setGoods("0000a20049","130","Dsmaru","72","64000","modern");
goods[118] =new setGoods("0000a20078","130","Dsmaru","72","64000","meisai");
goods[119] =new setGoods("0000a20086","130","Dsmaru","72","82000","magic");
goods[120] =new setGoods("0000a20093","160","Dsmaru","72","73000","modern");
goods[121] =new setGoods("0000a20122","160","Dsmaru","72","73000","meisai");
goods[122] =new setGoods("0000a20130","160","Dsmaru","72","91000","magic");
goods[123] =new setGoods("0000ae015712","64","Dskaku","72","57000","resort");
goods[124] =new setGoods("0000ae015717","64","Dskaku","72","64000","holiday");
goods[125] =new setGoods("0000ae015722","64","Dskaku","72","64000","meta");
goods[126] =new setGoods("0000ae015730","130","Dskaku","72","75000","resort");
goods[127] =new setGoods("0000ae015735","130","Dskaku","72","82000","holiday");
goods[128] =new setGoods("0000ae015740","130","Dskaku","72","82000","meta");
goods[129] =new setGoods("0000ae015748","160","Dskaku","72","84000","resort");
goods[130] =new setGoods("0000ae015753","160","Dskaku","72","91000","holiday");
goods[131] =new setGoods("0000ae015758","160","Dskaku","72","91000","meta");
goods[132] =new setGoods("0000ae015766","64","Dsjet","72","57000","resort");
goods[133] =new setGoods("0000ae015771","64","Dsjet","72","64000","holiday");
goods[134] =new setGoods("0000ae015776","64","Dsjet","72","64000","meta");
goods[135] =new setGoods("0000ae015784","130","Dsjet","72","75000","resort");
goods[136] =new setGoods("0000ae015789","130","Dsjet","72","82000","holiday");
goods[137] =new setGoods("0000ae015794","130","Dsjet","72","82000","meta");
goods[138] =new setGoods("0000ae015802","160","Dsjet","72","84000","resort");
goods[139] =new setGoods("0000ae015807","160","Dsjet","72","91000","holiday");
goods[140] =new setGoods("0000ae015812","160","Dsjet","72","91000","meta");
goods[141] =new setGoods("0000ae015820","64","Dsmaru","72","57000","resort");
goods[142] =new setGoods("0000ae015825","64","Dsmaru","72","64000","holiday");
goods[143] =new setGoods("0000ae015830","64","Dsmaru","72","64000","meta");
goods[144] =new setGoods("0000ae015838","130","Dsmaru","72","75000","resort");
goods[145] =new setGoods("0000ae015843","130","Dsmaru","72","82000","holiday");
goods[146] =new setGoods("0000ae015848","130","Dsmaru","72","82000","meta");
goods[147] =new setGoods("0000ae015856","160","Dsmaru","72","84000","resort");
goods[148] =new setGoods("0000ae015861","160","Dsmaru","72","91000","holiday");
goods[149] =new setGoods("0000ae015866","160","Dsmaru","72","91000","meta");
goods[150] =new setGoods("0000a20137","64","kaku","59","45000","modern");
goods[151] =new setGoods("0000a20166","64","kaku","59","45000","meisai");
goods[152] =new setGoods("0000a35656","64","kaku","59","68000","michael");
goods[153] =new setGoods("0000ae015415","64","kaku","59","51000","resort");
goods[154] =new setGoods("0000ae015420","64","kaku","59","63000","holiday");
goods[155] =new setGoods("0000ae015425","64","kaku","59","63000","meta");
goods[156] =new setGoods("0000a41060","64","kaku","59","63000","denim");
goods[157] =new setGoods("0000a20174","64","kaku","59","63000","magic");
goods[158] =new setGoods("0000a20181","130","kaku","59","63000","modern");
goods[159] =new setGoods("0000a20210","130","kaku","59","63000","meisai");
goods[160] =new setGoods("0000a35666","130","kaku","59","86000","michael");
goods[161] =new setGoods("0000ae015433","130","kaku","59","69000","resort");
goods[162] =new setGoods("0000ae015438","130","kaku","59","81000","holiday");
goods[163] =new setGoods("0000ae015443","130","kaku","59","81000","meta");
goods[164] =new setGoods("0000a41065","130","kaku","59","81000","denim");
goods[165] =new setGoods("0000a20218","130","kaku","59","81000","magic");
goods[166] =new setGoods("0000a20225","160","kaku","59","72000","modern");
goods[167] =new setGoods("0000a20254","160","kaku","59","72000","meisai");
goods[168] =new setGoods("0000a35676","160","kaku","59","95000","michael");
goods[169] =new setGoods("0000ae015451","160","kaku","59","78000","resort");
goods[170] =new setGoods("0000ae015456","160","kaku","59","90000","holiday");
goods[171] =new setGoods("0000ae015461","160","kaku","59","90000","meta");
goods[172] =new setGoods("0000a41070","160","kaku","59","90000","denim");
goods[173] =new setGoods("0000a20262","160","kaku","59","90000","magic");
goods[174] =new setGoods("0000a20269","64","jet","59","45000","modern");
goods[175] =new setGoods("0000a20298","64","jet","59","45000","meisai");
goods[176] =new setGoods("0000ae015469","64","jet","59","51000","resort");
goods[177] =new setGoods("0000ae015474","64","jet","59","63000","holiday");
goods[178] =new setGoods("0000ae015479","64","jet","59","63000","meta");
goods[179] =new setGoods("0000a20306","64","jet","59","63000","magic");
goods[180] =new setGoods("0000a20313","130","jet","59","63000","modern");
goods[181] =new setGoods("0000a20342","130","jet","59","63000","meisai");
goods[182] =new setGoods("0000ae015487","130","jet","59","69000","resort");
goods[183] =new setGoods("0000ae015492","130","jet","59","81000","holiday");
goods[184] =new setGoods("0000ae015497","130","jet","59","81000","meta");
goods[185] =new setGoods("0000a20350","130","jet","59","81000","magic");
goods[186] =new setGoods("0000a20357","160","jet","59","72000","modern");
goods[187] =new setGoods("0000a20386","160","jet","59","72000","meisai");
goods[188] =new setGoods("0000ae015505","160","jet","59","78000","resort");
goods[189] =new setGoods("0000ae015510","160","jet","59","90000","holiday");
goods[190] =new setGoods("0000ae015515","160","jet","59","90000","meta");
goods[191] =new setGoods("0000a20394","160","jet","59","90000","magic");
goods[192] =new setGoods("0000a10682","64","maru","59","45000","ns7");
goods[193] =new setGoods("0000a10670","64","maru","59","45000","sofia");
goods[194] =new setGoods("0000ae015542","64","maru","59","63000","leather");
goods[195] =new setGoods("0000a10692","64","maru","59","63000","moq");
goods[196] =new setGoods("0000a14355","64","maru","59","45000","modern");
goods[197] =new setGoods("0000ae015524","64","maru","59","45000","meisai");
goods[198] =new setGoods("0000ae015563","64","maru","59","68000","michael");
goods[199] =new setGoods("0000ae015527","64","maru","59","51000","resort");
goods[200] =new setGoods("0000ae015532","64","maru","59","63000","holiday");
goods[201] =new setGoods("0000ae015554","64","maru","59","63000","meta");
goods[202] =new setGoods("0000ae015537","64","maru","59","63000","denim");
goods[203] =new setGoods("0000ae015547","64","maru","59","63000","magic");
goods[204] =new setGoods("0000a10717","130","maru","59","63000","ns7");
goods[205] =new setGoods("0000a10705","130","maru","59","63000","sofia");
goods[206] =new setGoods("0000ae015605","130","maru","59","81000","leather");
goods[207] =new setGoods("0000a10727","130","maru","59","81000","moq");
goods[208] =new setGoods("0000a14356","130","maru","59","63000","modern");
goods[209] =new setGoods("0000ae015587","130","maru","59","63000","meisai");
goods[210] =new setGoods("0000ae015626","130","maru","59","86000","michael");
goods[211] =new setGoods("0000ae015590","130","maru","59","69000","resort");
goods[212] =new setGoods("0000ae015595","130","maru","59","81000","holiday");
goods[213] =new setGoods("0000ae015617","130","maru","59","81000","meta");
goods[214] =new setGoods("0000ae015600","130","maru","59","81000","denim");
goods[215] =new setGoods("0000ae015610","130","maru","59","81000","magic");
goods[216] =new setGoods("0000a10806","160","maru","59","72000","ns7");
goods[217] =new setGoods("0000a10794","160","maru","59","72000","sofia");
goods[218] =new setGoods("0000ae015668","160","maru","59","90000","leather");
goods[219] =new setGoods("0000a10816","160","maru","59","90000","moq");
goods[220] =new setGoods("0000a14357","160","maru","59","72000","modern");
goods[221] =new setGoods("0000ae015650","160","maru","59","72000","meisai");
goods[222] =new setGoods("0000ae015689","160","maru","59","95000","michael");
goods[223] =new setGoods("0000ae015653","160","maru","59","78000","resort");
goods[224] =new setGoods("0000ae015658","160","maru","59","90000","holiday");
goods[225] =new setGoods("0000ae015680","160","maru","59","90000","meta");
goods[226] =new setGoods("0000ae015663","160","maru","59","90000","denim");
goods[227] =new setGoods("0000ae015673","160","maru","59","90000","magic");